import React from 'react';
import Modal from 'react-bootstrap/lib/Modal';
import { connect } from 'react-redux';
import Button from 'react-bootstrap/lib/Button';
import classNames from 'classnames';
import get from 'lodash/get';
import * as actions from '../../../actions/response';
import ClaroUrlBuilder from '../../../utils/ClaroUrlBuilder';
import { converter } from '../../../helpers/converter';
import * as metricsActions from '../../../action-creators/metrics';
import * as constants from '../../../constants';
import Utils from '../../../utils/Utils';
import { isNewExperienceEnabledWNTranslations } from '../../../utils/isNewExperienceEnabled';

import { getCounterValidEmail } from '../../../action-creators/ip_telmex';
import getFirstNode from 'utils/getFirstNode';

const classButtonInactive = 'btn btn-default close-modal btn-block';

class ModalSuscSuccess extends React.Component {
  static defaultProps = {
    typeTransac: '',
  };

  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
    this.onAccept = this.onAccept.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.onPlay = this.onPlay.bind(this);

    // Set Metrics
    props.setMetricsEvent({
      type: 'executor',
      success: true,
    });
  }

  handleClick = next => {
    const userMailValidation = JSON.parse(
      this.props.metadata.user_mail_validation,
    );
    const counter = get(userMailValidation, 'mexico.limit');
    this.props
      .getCounterValidEmail(counter, next.bind(this))
      .then(wait => !wait && next());
  };

  closeModal() {
    if (this.props.queryParams && this.props.queryParams.group_id) {
      return window.location.replace(
        ClaroUrlBuilder.card(
          constants.GetRegion(),
          this.props.queryParams.group_id,
        ),
      );
    }
    return window.location.replace(ClaroUrlBuilder.home());
  }

  onAccept() {
    const fox =
      this.props.message &&
      this.props.message.toLowerCase().indexOf('fox') != -1;
    if (this.props.queryParams && this.props.queryParams.group_id) {
      return window.location.replace(
        ClaroUrlBuilder.card(
          constants.GetRegion(),
          this.props.queryParams.group_id,
        ),
      );
    }
    if (fox) {
      let pathFox = '';
      if (this.props.nav && this.props.nav.length > 0)
        pathFox = Utils.getPathFox(this.props.nav);
      return window.location.replace(`/${constants.GetRegion()}/${pathFox}`);
    }
    return window.location.replace(ClaroUrlBuilder.home());
  }

  onPlay() {
    const params = this.props.queryParams;
    const isMobile = Utils.MobileCheck();
    const firstNode = getFirstNode();

    if (isMobile) {
      return window.location.replace(
        `/${constants.GetRegion()}/devices?runplayerinapp&group_id=${
          params.group_id
        }`,
      );
    }

    if (params.group_id) {
      return window.location.replace(
        ClaroUrlBuilder.guideChannel(
          params.group_id,
          isNewExperienceEnabledWNTranslations(constants.GetRegion()),
        ),
      );
    }
    return this.props.navigate(`/${constants.GetRegion()}/${firstNode}`);
  }

  renderPlayOrAcceptButton() {
    const isProvider = this.props.translations[
      `payway_confirm_${this.props.llaveTexto}_ok`
    ];
    const register = this.props.translations.registro_aceptar;
    const enjoy = isProvider || register;

    const routing = this.props.queryParams;

    if (routing && routing.player_url && isProvider && routing.live) {
      return (
        <Button
          className={classButtonInactive}
          onClick={() => this.handleClick(this.onPlay)}
        >
          {converter.convertApaUnicode(
            this.props.translations,
            `payway_confirm_${this.props.llaveTexto}_ok`,
            'Comienza a disfrutar',
          )}
        </Button>
      );
    }

    return (
      <Button
        className={classButtonInactive}
        onClick={() => this.handleClick(this.onAccept)}
      >
        {enjoy}
      </Button>
    );
  }

  render() {
    const customIconClass = this.props.iconClass ? this.props.iconClass : false;

    const classes = {
      fa: true,
      'text-center': true,
      'fa-3x': true,
      'fa-check': !customIconClass,
    };

    if (customIconClass) classes[customIconClass] = customIconClass;

    const classesForBody = classNames(classes);
    return (
      <Modal show>
        <Modal.Header>
          <Button
            className="close close-modal"
            onClick={() => this.handleClick(this.closeModal)}
          >
            x
          </Button>
          <h4 className="text-center">{this.props.title}</h4>
        </Modal.Header>
        <Modal.Body className="modal-body text-center success">
          <i className={classesForBody} />
          <p
            className="padding-top-2"
            dangerouslySetInnerHTML={{ __html: this.props.message }}
          />
        </Modal.Body>
        <Modal.Footer className="modal_footer--susc">
          <div className="footer-modal-button flex-end modal_footer--button">
            <div className="col-lg-4 col-md-4 col-sm-4 col-xs-8 padding-top-05 modal_footer--button">
              {this.renderPlayOrAcceptButton()}
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  translations: state.translations,
  router: state.routing,
  metadata: state.metadata,
  nav: state.nav.nodeList,
});

const mapDispatchToProps = dispatch => ({
  closeModal(modalType) {
    dispatch(actions.removeModal(modalType));
  },
  setMetricsEvent(options) {
    dispatch(metricsActions.setMetricsEvent(options));
  },
  getCounterValidEmail(count, next) {
    return dispatch(getCounterValidEmail(count, next));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ModalSuscSuccess);
